var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#b21f1f",
    stroke: "#b21f1f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 832m-192 0a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z",
    fill: "#EF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 832m-192 0a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z",
    fill: "#EF4D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768 960a223.712 223.712 0 0 1-190.816-107.136A192 192 0 0 0 768 1024a192 192 0 0 0 190.816-171.136A223.712 223.712 0 0 1 768 960zM254.816 960A223.68 223.68 0 0 1 64 852.864 192 192 0 0 0 254.816 1024a192 192 0 0 0 190.816-171.136A223.712 223.712 0 0 1 254.816 960z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 256c0-67.776 10.112-173.312 19.808-197.984 7.136-18.144 21.696-41.536 1.696-53.536-20.512-15.488-59.264 17.856-59.264 17.856A1055.392 1055.392 0 0 0 241.568 640.704c4.768-0.32 9.568-0.704 14.432-0.704 17.184 0 33.76 2.464 49.6 6.688a990.24 990.24 0 0 1 278.784-521.696c0.032-0.224 0.128-0.288 0.192-0.512h0.224c-0.224 0.224-0.192 0.288-0.416 0.512A1066.528 1066.528 0 0 0 576 256c0 147.872 30.496 288.608 85.376 416.352a190.08 190.08 0 0 1 58.496-25.984A989.248 989.248 0 0 1 640 256z",
    fill: "#33d73e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.808 227.776s45.248-90.496-22.656-158.368c-67.872-67.872-158.368-22.624-158.368-22.624s-45.28 90.496 22.592 158.368c67.904 67.904 158.432 22.624 158.432 22.624z",
    fill: "#3AAD73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.784 46.784s-45.28 90.496 22.592 158.368c67.904 67.904 158.432 22.624 158.432 22.624l-181.024-180.992z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.224 608.416c-2.304 10.72-4.672 21.472-6.656 32.32 4.768-0.352 9.568-0.736 14.432-0.736 8.192 0 16.224 0.672 24.16 1.696l3.072 0.48c7.488 1.056 14.88 2.56 22.048 4.48l0.32 0.064c1.984-10.528 4.832-20.736 7.168-31.168A223.072 223.072 0 0 0 256 608c-2.624 0-5.152 0.32-7.776 0.416zM707.904 616.416a222.88 222.88 0 0 0-58.592 25.856c3.968 10.048 7.808 20.192 12.064 30.08l0.192-0.096c8.64-5.76 17.792-10.72 27.328-15.04l0.672-0.352c9.728-4.352 19.84-7.84 30.336-10.56-4.256-9.824-8.096-19.904-12-29.888z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832 736m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 736m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlots);
export default __webpack_public_path__ + "static/media/slots.fd45abac83cebf36d1bddd37ad0d3c33.svg";
export { ForwardRef as ReactComponent };